import BigNumber from 'bignumber.js'
import sousChefABI from 'config/abi/sousChef.json'
import poolsConfig from 'config/constants/pools'
import { QuoteToken } from 'config/constants/types'
import { useSousChef } from 'hooks/useContract'
import { useEffect, useState } from 'react'
import multicall from 'utils/multicall'

const CHAIN_ID = process.env.REACT_APP_CHAIN_ID

export const fetchPoolsBlockLimits = async () => {
  const poolsWithEnd = poolsConfig.filter((p) => p.sousId !== 0)
  const callsStartTime = poolsWithEnd.map((poolConfig) => {
    return {
      address: poolConfig.contractAddress[CHAIN_ID],
      name: 'startTime',
    }
  })
  const callsEndTime = poolsWithEnd.map((poolConfig) => {
    return {
      address: poolConfig.contractAddress[CHAIN_ID],
      name: 'bonusEndTime',
    }
  })

  const starts = await multicall(sousChefABI, callsStartTime)
  const ends = await multicall(sousChefABI, callsEndTime)

  return poolsWithEnd.map((cakePoolConfig, index) => {
    const startTime = starts[index]
    const endTime = ends[index]
    return {
      sousId: cakePoolConfig.sousId,
      startTime: new BigNumber(startTime).toJSON(),
      endTime: new BigNumber(endTime).toJSON(),
    }
  })
}

export const fetchPoolsTotalStatking = async () => {
  const nonBnbPools = poolsConfig.filter((p) => p.stakingTokenName !== QuoteToken.BNB)
  const bnbPool = poolsConfig.filter((p) => p.stakingTokenName === QuoteToken.BNB)

  const callsNonBnbPools = nonBnbPools.map((poolConfig) => {
    return {
      address: '0x0000000000000000000000000000000000000000',
      name: 'totalStakeTokenBalance',
    }
  })

  const callsBnbPools = bnbPool.map((poolConfig) => {
    return {
      address: '0x0000000000000000000000000000000000000000',
      name: 'totalStakeTokenBalance',
    }
  })

  const nonBnbPoolsTotalStaked = await multicall(sousChefABI, callsNonBnbPools)
  const bnbPoolsTotalStaked = await multicall(sousChefABI, callsBnbPools)

  return [
    ...nonBnbPools.map((p, index) => ({
      sousId: p.sousId,
      totalStaked: new BigNumber(nonBnbPoolsTotalStaked[index]).toJSON(),
    })),
    ...bnbPool.map((p, index) => ({
      sousId: p.sousId,
      totalStaked: new BigNumber(bnbPoolsTotalStaked[index]).toJSON(),
    })),
  ]
}

// FETCH POOL END TIME
export const EndTime = (id) => {
  const [bonusEndTime, setBonusEndTime] = useState(null)
  const sousCon = useSousChef(id)

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await sousCon.methods.bonusEndTime().call()
        setBonusEndTime(new BigNumber(res))
      } catch (e) {
        setBonusEndTime(null)
      }
    }
    fetch()
  }, [sousCon])

  return bonusEndTime
}

// FETCH POOL START TIME
export const StartTime = (id) => {
  const [startTime, setStartTime] = useState(null)
  const sousCon = useSousChef(id)

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await sousCon.methods.startTime().call()
        setStartTime(new BigNumber(res))
      } catch (e) {
        setStartTime(null)
      }
    }
    fetch()
  }, [sousCon])

  return startTime
}

// FETCH TOTAL STAKED BALANCE
export const SousTotalBal = (id) => {
  const [totalStakeTokenBalance, setTotalStakeTokenBalance] = useState(null)
  const sousCon = useSousChef(id)

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await sousCon.methods.totalStakeTokenBalance().call()
        setTotalStakeTokenBalance(res)
      } catch (e) {
        setTotalStakeTokenBalance(null)
      }
    }
    fetch()
  }, [sousCon])

  return totalStakeTokenBalance
}

// FETCH REMAINING REWARDS
export const RewardsRemaining = (id) => {
  const [rewardBalance, setRewardBalance] = useState(null)
  const sousCon = useSousChef(id)

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await sousCon.methods.rewardBalance().call()
        setRewardBalance(new BigNumber(res))
      } catch (e) {
        setRewardBalance(null)
      }
    }
    fetch()
  }, [sousCon])

  return rewardBalance
}
